import * as user from './user';

const thunks = {
    user,
};

export default thunks;
